<template>
  <div class="mm-page-main">
    <div class="page-header">
      <div class="page-title">編輯銀行戶主</div>
      <div @click="pageback" class="page-back">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-back"></use>
        </svg>
      </div>
    </div>
    <div class="pagemain">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px" label-position="left">
        <div class="form-group">
          <div class="form-group-content">
            <!-- <div class="mm-row">
							<div class="mm-col">
								<el-form-item label="代號" prop="code">
									<el-input v-model="form.code"></el-input>
								</el-form-item>
							</div>
						</div> -->
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="戶主姓名" prop="name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="身份證卡號" prop="card">
                  <el-input v-model="form.card"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="戶主電話" prop="phone">
                  <el-input v-model="form.phone"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="負責人" prop="holderman">
                  <el-input v-model="form.holderman"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="負責人電話" prop="holder_phone">
                  <el-input v-model="form.holder_phone"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="代理人" prop="agentman">
                  <el-input v-model="form.agentman"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="代理人電話" prop="agent_phone">
                  <el-input v-model="form.agent_phone"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="銀行卡">
                  <el-radio v-model="form.cardtype" label="0">公司</el-radio>
                  <el-radio v-model="form.cardtype" label="1">代理</el-radio>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="銀行USB">
                  <el-radio v-model="form.usb" label="0">公司</el-radio>
                  <el-radio v-model="form.usb" label="1">代理</el-radio>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="租/買">
                  <el-radio v-model="form.buytype" label="0">出租</el-radio>
                  <el-radio v-model="form.buytype" label="1">購買</el-radio>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="戶口到埗日期" prop="endtime">
                  <el-date-picker type="date" placeholder="選擇日期" v-model="form.endtime" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="戶口提示日期" prop="tipstime">
                  <el-date-picker type="date" placeholder="選擇日期" v-model="form.tipstime" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="戶口起租日期" prop="startrent_time">
                  <el-date-picker type="date" placeholder="選擇日期" v-model="form.startrent_time" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row">
              <div class="mm-col">
                <el-form-item label="戶口交租日期" prop="endrent_time">
                  <el-date-picker type="date" placeholder="選擇日期" v-model="form.endrent_time" style="width: 100%;"></el-date-picker>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

        <div class="form-submit">
          <el-button @click="formsubmit('form')" type="primary">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {

  data () {
    return {
      form: {
        cardtype: '0',
        usb: '0',
        buytype: '0'
      },
      rules: {
        name: [{
          required: true,
          message: '請輸入戶主姓名',
        },
        ],
        card: [{
          required: true,
          message: '請輸入身份證卡號',
        },
        ],
        phone: [{
          required: true,
          message: '請填寫電話號碼',
        }, {
          pattern: /^[0-9,，]+$/,
          message: '只能輸入數字和“,”'
        }],
        holderman: [{
          pattern: /^[\S]+$/,
          message: '只能輸入可見字符'
        }],
        holder_phone: [{
          pattern: /^[0-9,，]+$/,
          message: '只能輸入數字和“,”'
        }],
        agentman: [{
          pattern: /^[\S]+$/,
          message: '只能輸入可見字符'
        }],
        agent_phone: [{
          pattern: /^[0-9,，]+$/,
          message: '只能輸入數字和“,”'
        }],





      }
    };
  },
  methods: {

    pageback () {
      this.$router.go(-1);
    },
    formsubmit (form) {

      this.$refs[form].validate((valid) => {
        if (valid) {
          let data = this.form;
          this.loading = true;
          this.post('/api/bank/bank_holder_edit_save', {
            data: data
          }).then((res) => {

            if (res == 'success') {
              this.$message({
                showClose: true,
                message: '編輯戶主信息成功！',
                type: 'success',
                onClose: (() => {
                })
              });
              this.pageback();
            } else {
              this.$message({
                showClose: true,
                message: '編輯戶主信息失敗，請重試！',
                type: 'error',

              });
            }

            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        }
      });
    },
    geteditdata () {

      let row = this.$route.params.row;
      this.form = row;
      let buytype = row.buytype.toString();
      let usb = row.usb.toString();
      let cardtype = row.cardtype.toString();
      this.form.buytype = buytype;
      this.form.usb = usb;
      this.form.cardtype = cardtype;

    },


  },
  created () {

    this.geteditdata();
  }

};
</script>
<style scoped>
</style>
